import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { Titulos } from 'types/Titulos';

export async function getTitulos(institucionId: number | undefined): Promise<Titulos[]> {
  try {
    const url = new URL(`${ config.baseUrl }/titulos`);

    if (institucionId !== undefined) {
      url.searchParams.append('institucion_id', institucionId.toString());
    }

    type Response = APIResponse<Titulos[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      throw new Error('Ocurrió un problema de conexión al momento de intentar recuperar los títulos.');
    }

    const content = await response.json() as Response;
    if (content.status !== 'ok' || !content.payload) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar los títulos.');
    }

    return content.payload;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
